import React, { Component } from 'react';

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ShowItemBtn from '../../../../components/ShowItemBtn/ShowItemBtn';

import Modal from './Modal';

class CondicionesDePago extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Codigo",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre En SIGE",
                    id: "NombreEnSIGE",
                    accessor: d => d.NombreEnSIGE,
                    show: true,
                },
                {
                    Header: "Nombre en Web",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Visible",
                    id: "Show",
                    accessor: d => d.Show ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 100,
                    className: "text-center",
                },
                {
                    Header: "% Recargo",
                    id: "PorcentajeRecargo",
                    accessor: d => d.PorcentajeRecargo.toFixed(2),
                    show: true,
                    width: 100,
                    className: "text-right",
                },
                {
                    Header: "% Descuento",
                    id: "PorcentajeDescuento",
                    accessor: d => d.PorcentajeDescuento.toFixed(2),
                    show: true,
                    width: 100,
                    className: "text-right",
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 100,
                    className: "text-center",
                },
            ],
        };
    }

    render() {
        const { modernTheme } = this.props;
        const propsShowItemBtn = {
            label: 'Condicion de Pago',
            labelMany: 'Condiciones de Pagos',
            submitUrl: api.gestion.ventas.condicionesdepagoMostrarOcultar,
            femaleLabel: true
        }
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'ecommerce_ventas_condicionesdepago_edit',
                    },
                    {
                        detail: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'ecommerce_ventas_condicionesdepago_detail',
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="MOSTRAR" />),
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="OCULTAR" />),
                    },
                ]}
                outerFilter={[{ id: "DeBaja", lookup: "exact", value: "False" }]}
                apiUrl={api.gestion.ventas.condicionesdepago}
                columns={this.state.columns}
                title={"Condiciones de Pago"}
                multiSelect={true}
                ctrlKeyMultiSelect={true}
            />
        );
    }
}

export default CondicionesDePago;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/CondicionesDePago/CondicionesDePago.js